/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-disable import/no-unresolved, import/default */

import siloWidgetTemplate from './silo-widget.tpl.html';
import siloWidgetToolbarTemplate from './silo-widget-toolbar.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloWidget', [])
    .directive('agSiloWidget', SiloWidget)
    .name;

/*@ngInject*/
function SiloWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiloWidgetController,
        controllerAs: 'vm',
        templateUrl: siloWidgetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SiloWidgetController($scope, $element, $compile, $templateCache, $translate, agTypes, siloService) {

    let vm = this;
    vm.agTypes = agTypes;
    vm.siloId = null;
    vm.silo = null;
    vm.hasConnectedSystems = false;
    vm.siloLoading = false;

    var parents = $element.parents('.tb-widget');
    parents.children('.tb-widget-header').css('paddingRight', '40px');
    $element.parents('.tb-widget-content').css('paddingRight', '40px');

    var toolbarTemplate = $templateCache.get(siloWidgetToolbarTemplate);
    var toolbarElement = angular.element(toolbarTemplate);
    angular.element(parents[1]).append(toolbarElement);
    $compile(toolbarElement.contents())($scope);

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.siloWidgetTypes = agTypes.siloWidgetType;
            vm.ctx.currentWidgetType = null;
            vm.ctx.settings.displayPagination = false;
            vm.ctx.settings.alarmsTitle = $translate.instant('alarm.alarms') + ': ${entityName}';

            vm.siloId = null;
            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSilo();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        loadSilo();
                    }
                }
            );
        }
    });

    function loadSilo() {
        vm.siloLoading = true;
        vm.silo = null;
        vm.hasConnectedSystems = false;
        if (vm.siloId) {
            siloService.getSilo(vm.siloId).then(
                function success(silo) {
                    vm.silo = silo;
                    siloService.getSiloConnectedSystems(vm.siloId).then(
                        function success(connectedSystems) {
                            vm.hasConnectedSystems = connectedSystems && connectedSystems.length > 0;

                            if (!vm.silo.hasHeadSpaceSensor && !vm.silo.hasMoistureCables && !vm.silo.hasCO2Cables && !vm.hasConnectedSystems) {
                                vm.ctx.currentWidgetType = agTypes.siloWidgetType.siloTemperatureDetails;
                            } else {
                                vm.ctx.currentWidgetType = agTypes.siloWidgetType.siloOverview;
                            }
                            vm.siloLoading = false;
                        },
                        function fail() {
                            vm.siloLoading = false;
                        }
                    );
                },
                function fail() {
                    vm.siloLoading = false;
                }
            );
        }
    }
}
